import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

interface IFinanceType {
  value: any;
  changeValue: any;
  ranges?: any;
}

const SideFilter: React.FC<IFinanceType> = ({ value, changeValue, ranges }) => {
  const submit = (element: any, value: any) => {
    changeValue("type", value);
  };

  return (
    <FormControl component="fieldset" id="filter-finance-type-side">
      <RadioGroup name="type" value={value} onChange={submit}>
        <FormControlLabel
          control={<Radio color="primary" />}
          value="buy"
          label={
            <FormattedMessage
              id="filter.financial.type.options.purchase.label"
              defaultMessage="Kaufpreis"
            />
          }
        />
        {ranges.has("runtime") && (
          <FormControlLabel
            control={<Radio color="primary" />}
            value="lease"
            label={
              <FormattedMessage id="filter.financial.type.options.monthly.label" />
            }
          />
        )}
      </RadioGroup>
    </FormControl>
  );
};
const DropdownFilter: React.FC<IFinanceType> = ({
  value,
  changeValue,
  ranges,
}) => {
  const { formatMessage: t } = useIntl();

  const setValueHandler = (event: SelectChangeEvent) => {
    const value = event.target.value;
    changeValue("type", value);
  };

  return (
    <FormControl component="fieldset" size="small" fullWidth>
      <InputLabel id="filter-finance-type-label">
        <FormattedMessage
          id="filter.finance.type.label"
          defaultMessage="Finanzierung"
        />
      </InputLabel>
      <Select
        fullWidth
        labelId="filter-finance-type-label"
        id="filter-finance-type-simple"
        value={value}
        label={t({
          id: "filter.finance.type.label",
          defaultMessage: "Finanzierung",
        })}
        onChange={setValueHandler}
      >
        <MenuItem value={"buy"}>Barpreis</MenuItem>
        {ranges.has("runtime") && (
          <MenuItem value={"lease"}>Monatliche Rate</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

interface IContainer extends IFinanceType {
  variant?: string;
}

const Container: React.FC<IContainer> = ({
  variant = "side",
  value,
  changeValue,
  ranges,
}) => {
  let Filter;
  switch (variant) {
    case "dropdown":
      Filter = DropdownFilter;
      break;
    default:
      Filter = SideFilter;
  }
  return (
    <Filter
      {...{
        value,
        changeValue,
        ranges,
      }}
    />
  );
};

export default Container;
